export const RolesTypes = {
  SUPERUSER: "SUPER_USER",
  COACH: "COACH",
  STUDENT: "STUDENT"
};